import React from "react";
import CaseStudyPage from "./CaseStudyPage";

const CaseStudyOneHive = () => (
  <CaseStudyPage
    category="Healthtech"
    client="OneHive Healthcare"
    title="How We Built the AI Infrastructure Powering an Entire RCM Company"
    heroImage="https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1600&q=80"
    challenge="Running an RCM company at 4% net collections — well below the industry standard of 6–7% — requires doing more with significantly less. Manual prior auth, denial triage, and EOB processing were the three largest cost centers, each requiring dedicated staff and constant supervision. Scaling the business without scaling headcount meant AI had to carry the operational load."
    whatWeBuilt="Synentia designed and deployed the complete AI infrastructure that OneHive runs on today — prior auth automation agents that track and follow up on outstanding authorizations without human intervention, a denial triage system that classifies denials by reason code and routes appeals automatically, multimodal document processing that reads and reconciles EOBs at scale, and a full observability layer that monitors every AI system in production with monthly performance reporting."
    results={[
      { value: "60%+", label: "Reduction in manual prior auth follow-up time" },
      { value: "Automated", label: "Denial triage for most common reason codes" },
      { value: "At scale", label: "EOB processing handled without additional billing staff" },
      { value: "Continuous", label: "AI infrastructure operating across full client portfolio" },
      { value: "4%", label: "Cost-to-serve enabling competitive net collections pricing" },
    ]}
    takeaway="OneHive isn't just a client. It's proof that the AI systems Synentia builds work in production, at scale, in one of the most complex operational environments in US healthcare."
  />
);

export default CaseStudyOneHive;
